import { AnimatePresence, motion } from "framer-motion";
import { ReactNode } from "react";

type Props = {
	showModal: boolean;
	setShowModal: (showModal: boolean) => void;
	content: ReactNode;
	showCloseButton?: boolean;
	dismissOnBackdropClick?: boolean;
	className?: string;
};

export default function AnimationPopup({
	showModal,
	setShowModal,
	content,
	showCloseButton = true,
	dismissOnBackdropClick = true,
	className,
}: Props) {
	return (
		<AnimatePresence>
			{showModal && (
				<motion.div
					initial={{ opacity: 0 }}
					animate={{ opacity: 1 }}
					exit={{ opacity: 0 }}
					className="fixed inset-0 bg-black bg-opacity-30 flex items-end justify-center z-50 w-full"
					onClick={dismissOnBackdropClick ? () => setShowModal(false) : undefined}
				>
					<motion.div
						initial={{ y: 500, opacity: 0 }}
						animate={{ y: 0, opacity: 1 }}
						exit={{ y: 500, opacity: 0 }}
						transition={{
							type: "spring",
							damping: 25,
							stiffness: 300,
						}}
						onClick={(e) => e.stopPropagation()}
						className={
							className ??
							"relative flex justify-center bg-white rounded-t-3xl p-6 pb-14 w-full max-h-[90%] overflow-y-auto"
						}
					>
						{showCloseButton && (
							<button
								onClick={() => setShowModal(false)}
								className="absolute top-2 right-4 text-gray-400 hover:text-gray-600 text-2xl"
							>
								✕
							</button>
						)}
						<div className="flex flex-col h-full items-center justify-center">{content}</div>
					</motion.div>
				</motion.div>
			)}
		</AnimatePresence>
	);
}
